import {CanActivateFn, Router} from "@angular/router";
import {AuthService} from "../modules/auth/services/auth.service";
import {inject} from "@angular/core";
import {map} from "rxjs";

const LEGAL_COMPLETION_ROUTE = "/complete-signup";

export const authGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const redirectTo = route.queryParamMap.get("redirectTo");

  if (!authService.user) {
    return true;
  }

  return authService.syncLegalAcceptance().pipe(
    map((hasAcceptedLegalDocuments) => {
      if (!hasAcceptedLegalDocuments) {
        return router.createUrlTree([LEGAL_COMPLETION_ROUTE], {
          queryParams: {redirectTo: resolveSafeRedirect(redirectTo)},
        });
      }

      return router.parseUrl(resolveSafeRedirect(redirectTo));
    })
  );
};

export function resolveSafeRedirect(redirectTo: string | null): string {
  if (
    !redirectTo ||
    !redirectTo.startsWith("/") ||
    redirectTo.startsWith("//") ||
    redirectTo.startsWith(LEGAL_COMPLETION_ROUTE)
  ) {
    return "/";
  }

  return redirectTo;
}
